import {
  executeGet,
  executePost,
  executePut,
  executeDelete
} from '@/api/AxiosUtil'
import axios from 'axios'
import { logger } from '@/logger'

export const getCategories = () => {
  return executeGet('/api/v2/print-store/category')
}

export const getProductTypes = () => {
  return executeGet('/api/v2/print-store/product-type')
}

export const getCategoryContent = (id) => {
  return executeGet(`/api/v2/print-store/category-content/${id}`)
}

export const getCategory = (id) => {
  return executeGet(`/api/v2/print-store/category/${id}`)
}

export const getSharedItems = () => {
  return executeGet(`/api/v2/print-store/category-content/shared`)
}

export const addCategory = (model) => {
  return executePost('/api/v2/print-store/category', model)
}

export const updateCategory = (model) => {
  return executePut(`/api/v2/print-store/category/${model.id}`, model)
}

export const deleteCategory = (id) => {
  return executeDelete(`/api/v2/print-store/category/${id}`)
}

export const getCollection = (id) => {
  return executeGet(`/api/v2/print-store/collection/${id}`)
}

export const addCollection = (model) => {
  return executePost('/api/v2/print-store/collection', model)
}

export const updateCollection = (model) => {
  return executePut(`/api/v2/print-store/collection/${model.id}`, model)
}

export const getCollections = () => {
  return executeGet('/api/v2/print-store/collection')
}

export const getCollectionContent = (id) => {
  return executeGet(`/api/v2/print-store/collection-content/${id}`)
}

export const deleteCollection = (id) => {
  return executeDelete(`/api/v2/print-store/collection/${id}`)
}

export const getPackage = (id) => {
  return executeGet(`/api/v2/print-store/package/${id}`)
}

export const addPackage = (model) => {
  return executePost('/api/v2/print-store/package', model)
}

export const updatePackage = (model) => {
  return executePut(`/api/v2/print-store/package/${model.id}`, model)
}

export const deletePackage = (id) => {
  return executeDelete(`/api/v2/print-store/package/${id}`)
}

export const getProduct = (id) => {
  return executeGet(`/api/v2/print-store/product/${id}`)
}

export const getProductPreviewId = (id) => {
  return executePost(`/api/v2/print-store/preview/${id}`)
}

export const getAllProducts = () => {
  return executeGet(`/api/v2/print-store/product`)
}

export const addProduct = (model) => {
  return executePost('/api/v2/print-store/product', model)
}

export const updateProduct = (model) => {
  return executePut(`/api/v2/print-store/product/${model.id}`, model)
}

export const deleteProduct = (id) => {
  return executeDelete(`/api/v2/print-store/product/${id}`)
}

export const placeOrder = (model) => {
  return executePost('/api/v2/print-store/order', model)
}

export const displayOrder = (model) => {
  return executePost(
    `/api/v2/print-store/collection/${model.id}/display-order`,
    model.displayOrder
  )
}

export const clearDisplayOrder = (collectionId) => {
  return executeDelete(
    `/api/v2/print-store/collection/${collectionId}/display-order`
  )
}

export const displayCollectionOrder = (model) => {
  return executePost(
    `/api/v2/print-store/category/${model.id}/display-order`,
    model.displayOrder
  )
}

export const getDashboardCollection = (apendDefaults) => {
  return executeGet(
    `/api/v2/print-store/dashboard-collection?appendDefaults=${apendDefaults}`
  )
}

export const getDefaultCategories = () => {
  return executeGet(`/api/v2/print-store/default-category`)
}

export const getCustomTemplate = (id) => {
  return executeGet(`/api/v3/xm/template/${id}`)
}

export const generateFile = (
  id,
  value = {},
  documentId = '',
  profileId = 16
) => {
  return executePost(`/api/v3/xm/generate/${id}`, {
    fielddata: value,
    profileid: profileId,
    documentid: documentId
  })
}

export const publishCustomProduct = (customProductSpecs) => {
  return executePost(
    '/api/v3/print-store/save-custom-product',
    customProductSpecs
  )
}

/*
  options object:
  - searchString - required
  - productTypeId - optional
 */
export const searchPrintStore = (options, searchDefault) => {
  return new Promise((resolve, reject) => {
    const url = `/api/v2/print-store/search?q=${options.searchString}&d=${searchDefault}`

    axios
      .get(url)
      .then((response) => resolve(response.data))
      .catch((error) => {
        logger.error(error)
        reject()
      })
  })
}

/*
 get random printStore products available for ad,
 if count is empty all products will be returned
*/
export const getRandomPrintStoreProducts = (count = 0, select) => {
  return new Promise((resolve, reject) => {
    let query
    if (count === 0) {
      query = `/api/v2/print-store/random-product`
    } else {
      query = `/api/v2/print-store/random-product?quantity=${count}&select=${select}`
    }
    axios
      .get(query)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => {
        console.error(error)
        reject()
      })
  })
}

export const getPriceTable = (file) => {
  const fileName = file.split('.').slice(0, -1).join('.')
  const priceTable = '/api/v2/printstore-pricing/' + fileName

  return new Promise((resolve, reject) => {
    axios
      .get(priceTable)
      .then((response) => {
        resolve(response.data)
      })
      .catch((error) => reject())
  })
}
